/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_SubtitleInputs */

const cs_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová kancelář na 30denní zkušební verzi`)
};

const en_auth_signup_subtitle = /** @type {(inputs: Auth_Signup_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new office on a 30-day trial`)
};

/**
* | output |
* | --- |
* | "A new office on a 30-day trial" |
*
* @param {Auth_Signup_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_subtitle = /** @type {((inputs?: Auth_Signup_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_subtitle(inputs)
	return cs_auth_signup_subtitle(inputs)
});